import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Spin, Select } from 'antd';
import debounce from 'lodash-es/debounce';

const { Option } = Select;

function NameSearch(props) {
  const {
    value,
    onChange,
    fetchAPI,
    dataField,
    valueKey,
    labelKey,
    label,
    fetchKey,
    optionExtractor
  } = props;
  const [fetching, setFetching] = useState(false);
  const [data, setData] = useState([]);

  const fetchNames = debounce(async search => {
    setFetching(true);
    const {
      result: { [dataField]: dataSets }
    } = await fetchAPI({
      [fetchKey]: search
    });

    setFetching(false);
    setData(
      dataSets.map(
        optionExtractor
          ? optionExtractor
          : item => ({
              text: item[labelKey || 'name'],
              value: item[valueKey]
            })
      )
    );
  }, 800);

  const handleChange = val => {
    setData([]);
    setFetching(false);
    onChange(val);
  };

  return (
    <Select
      mode="multiple"
      labelInValue
      value={value}
      placeholder={label || 'Name'}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      filterOption={false}
      onSearch={fetchNames}
      onChange={handleChange}
      style={{ width: '100%' }}
    >
      {data &&
        data.map(d => {
          return <Option key={d.value}>{d.text}</Option>;
        })}
    </Select>
  );
}

NameSearch.propTypes = {
  valueKey: PropTypes.string.isRequired,
  labelKey: PropTypes.string,
  dataField: PropTypes.string.isRequired,
  fetchAPI: PropTypes.func.isRequired,
  fetchKey: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  label: PropTypes.string,
  optionExtractor: PropTypes.func
};

NameSearch.defaultProps = {
  fetchKey: 'name'
};

export default NameSearch;
